import * as React from 'react';

interface ICommonPopoverContext {
    isOpen: boolean;
    closePopover: () => void;
}

const CommonPopoverContext = React.createContext<ICommonPopoverContext>(null);

export { CommonPopoverContext };
